export default __webpack_public_path__ + "aerosleep-logo.7a05f96.svg";